<template>
  <div>
    <h1>{{ $store.state.user.langEng ? 'Page not found' : 'Sidan finns inte' }}</h1>
    <br />
    <p>{{ $store.state.user.langEng ? "Couldn't find page: " + url : 'Hittade inte sidan: ' + url }}</p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      url: this.$route.fullPath
    };
  }
};
</script>

<style scoped>
  h1 {
    font-size: 2em;
  }
</style>
